import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import './Header.css';
import { IMAGE_CONFIGS } from './utils/imageUtils';

Modal.setAppElement('#root');

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  // 現在のパスに基づいてアクティブなリンクを判定
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // メニュー項目を選択した後にメニューを閉じる処理
  const closeMenu = () => {
    setMenuOpen(false);
    window.scrollTo(0, 0); // ページの一番上へスクロール
  };

  return (
    <header className="header">
      <div className="inner">
      <div className="logo">
        <Link to="/" className="logo-link" onClick={closeMenu}>
          <img 
            src={IMAGE_CONFIGS.logo.src} 
            alt={IMAGE_CONFIGS.logo.alt} 
            className="topLogo"
            width={IMAGE_CONFIGS.logo.width}
            height={IMAGE_CONFIGS.logo.height}
          />
        </Link>
      </div>
      {isMobile && (
        <div className="menu-icon" onClick={toggleMenu}>
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'}></i>
        </div>
      )}
      {isMobile ? (
        <Modal
          isOpen={menuOpen}
          onRequestClose={toggleMenu}
          className="nav-modal"
          overlayClassName="nav-modal-overlay"
        >
          <ul className="nav-links">
            <li onClick={closeMenu}>
              <Link to="/" className={isActive('/') ? 'active' : ''}>ホーム</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/company" className={isActive('/company') ? 'active' : ''}>会社案内</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/service" className={isActive('/service') ? 'active' : ''}>サービス紹介</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/recruit" className={isActive('/recruit') ? 'active' : ''}>採用情報</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/media" className={isActive('/media') ? 'active' : ''}>メディア</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>お問い合わせ</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/case-studies" className={isActive('/case-studies') || isActive('/case-study') ? 'active' : ''}>導入事例</Link>
            </li>
          </ul>
        </Modal>
      ) : (
        <nav>
          <ul className="nav-links">
            <li onClick={closeMenu}>
              <Link to="/" className={isActive('/') ? 'active' : ''}>ホーム</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/company" className={isActive('/company') ? 'active' : ''}>会社案内</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/service" className={isActive('/service') ? 'active' : ''}>サービス紹介</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/recruit" className={isActive('/recruit') ? 'active' : ''}>採用情報</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/media" className={isActive('/media') ? 'active' : ''}>メディア</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/case-studies" className={isActive('/case-studies') || isActive('/case-study') ? 'active' : ''}>導入事例</Link>
            </li>
            <li onClick={closeMenu}>
              <Link to="/contact" className={isActive('/contact') ? 'active' : ''}>お問い合わせ</Link>
            </li>
            <li onClick={closeMenu} className="helpful-materials-button">
              <Link to="/content" className={isActive('/content') ? 'active' : ''}>お役立ち資料</Link>
            </li>
          </ul>
        </nav>
      )}
      </div>
    </header>
  );
}

export default Header;
